import { Outlet } from "react-router"
import { PageFeedback } from "~/components/PageFeedback"

export default function GuidesLayout() {
  return (
    <div className="h-full overflow-y-auto px-12 py-8">
      <div className="mx-auto w-full max-w-screen-xl">
        <Outlet />
        <PageFeedback />
      </div>
    </div>
  )
}
